// extracted by mini-css-extract-plugin
module.exports = {"container":"container___30Sj0","menu":"menu___1WsUW","menuItem":"menuItem___3QSlR","icon":"icon___2F_OD","text":"text___2uz4h"};